module.exports = __webpack_public_path__ + "static/img/banner_医嘱与病历.92790ae9.png";